// src/pages/materials/MaterialsCheck.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Card = ({ title, desc, onClick }) => (
  <button
    onClick={onClick}
    className="block w-full text-left border rounded-lg p-4 hover:bg-gray-50 active:bg-gray-100 transition-colors"
  >
    <div className="text-sm font-semibold text-gray-900">{title}</div>
    <div className="text-xs text-gray-500 mt-1">{desc}</div>
  </button>
);

export default function MaterialsCheck() {
  const nav = useNavigate();
  const { id: projectId } = useParams();

  const goOfficial = (stage) => {
    const s = String(stage).toUpperCase(); // 'REQ' | 'CON'
    nav(`/project/${projectId}/materials/check/new/`);
  };

  return (
    <div
      className="mobile-page-root mb-16"
      style={{
        width: "100%",
        maxWidth: "100vw",
        minWidth: 0,
        display: "flex",
        justifyContent: "center",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{
          width: "100%",
          maxWidth: "480px",
          margin: "0 auto",
          padding: "0 1rem 1rem",
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        {/* 헤더 */}
        <div className="bg-white rounded-lg p-4 border">
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0 flex-1">
              <h2 className="text-lg font-bold text-gray-900 truncate">
                검수 문서 작성
              </h2>
            </div>
            <button
              className="btn-basic-sm flex-shrink-0"
              onClick={() => nav(-1)}
            >
              뒤로
            </button>
          </div>
        </div>

        {/* 공식 규격 템플릿 직행 */}
        <div className="bg-white rounded-lg border overflow-hidden">
          <div className="border-b px-4 py-3 font-medium bg-gray-50">
            공식 규격 템플릿
          </div>
          <div className="grid gap-3 p-4">
            <Card
              title="검수 요청서 (REQ)"
              desc="입고/공정 전 검수 요청 공식 양식"
              onClick={() => goOfficial("REQ")}
            />
            <Card
              title="검수 확인서 (CON)"
              desc="검수 결과 확인/확정 공식 양식"
              onClick={() => goOfficial("CON")}
            />
          </div>
        </div>

        <div className="bg-white rounded-lg border p-4">
          <p className="text-xs text-gray-500">
            * 생성 후 상세 화면에서 상태(임시저장/승인/종결) 등을 설정합니다.
          </p>
        </div>
      </div>
    </div>
  );
}
